export default __webpack_public_path__ + "static/media/trade.185f2610.svg";